import api from "!../../../../style-loader@2.0.0_webpack@5.75.0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../css-loader@5.2.7_webpack@5.75.0/node_modules/css-loader/dist/cjs.js!../../../../sass-loader@11.1.1_node-sass@8.0.0_webpack@5.75.0/node_modules/sass-loader/dist/cjs.js!./index.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};